<template>
	<section class="external-container moblie-wrapper">
		<div class="content">
			<van-form ref="applyForm" :data="applyData" :rules="rules">
				<div class="con-filed one-filed">
					<div class="con-title">用工类型
						<i class="van-icon van-icon-arrow van-cell__right-icon u-arrow--unexpanded"
                	:class="{'u-arrow--expanded': expandFlag}" @click="expandFlag = !expandFlag"></i>
					</div>
					<div class="con-list" v-if="expandFlag">
						<van-field v-if="!isDetail" is-link clickable readonly class="comptextarea select"  v-model="companyName"  :rules="[{ required: true, message: '合同主体不能为空', trigger: 'onChange' }]" prop="company" required  label="合同主体" placeholder="请选择合同主体"
						 @click="selectValue(companyTypeList,'companyTypeList', 'companyName')" type="textarea" autosize rows="1" />
						 <van-field v-else disabled required v-model="applyData.companyDescr" class="comptextarea comp-detail" type="textarea" autosize rows="1"  label="合同主体"/>
						<van-field class="select" is-link v-if="!isDetail" v-model="emplTypeName" clickable readonly prop="emplType" required  label="人员类别" placeholder="请选择人员类别"
							:rules="[{ required: true, message: '人员类别不能为空', trigger: 'blur' }]"  @click="selectValue(emplTypeList,'emplTypeList', 'emplTypeName')"/>
						 <van-field v-else disabled required v-model="applyData.emplTypeDescr"  label="人员类别"/>
					</div>
				</div>

				<!-- 基本信息 -->
				<div class="con-filed">
					<div class="con-title">基本信息
						<i class="van-icon van-icon-arrow van-cell__right-icon u-arrow--unexpanded"
                	:class="{'u-arrow--expanded': baseExpandFlag}" @click="baseExpandFlag = !baseExpandFlag"></i>
					</div>
					<BaseInfo
						v-if="baseExpandFlag"
						:data="applyData" 
						:isDetail="isDetail"
						@checkId="checkId"></BaseInfo>
				</div>
				<!-- 任职信息 -->
				<div class="con-filed">
					<div class="con-title">
						任职信息
						<i class="van-icon van-icon-arrow van-cell__right-icon u-arrow--unexpanded"
                	:class="{'u-arrow--expanded': jobExpandFlag}" @click="jobExpandFlag = !jobExpandFlag"></i>
					</div>
					<JobInfo
						ref="jobInfo"
						v-if="jobExpandFlag"
						:data="applyData" 
						:isDetail="isDetail"
						:socailFlag="socailFlag"
						:emplTypeTransCode="emplTypeTransCode"
						@select="getIsSubsidyFlag"
						></JobInfo>
				</div>
				<!-- 现金收入 -->
				<div class="con-filed" v-if="isShowPay || (isDetail && !(applyData.basePay === '0.00' || !applyData.basePay))">
					<div class="con-title">
						现金收入和期权
						<i class="van-icon van-icon-arrow van-cell__right-icon u-arrow--unexpanded"
                	:class="{'u-arrow--expanded': payExpandFlag}" @click="payExpandFlag = !payExpandFlag"></i>
					</div>
					<div class="con-list" v-if="payExpandFlag">
						<van-field v-model="applyData.basePay" :disabled="isDetail" :rules="[{ required: true, message: '请输入基本工资', trigger: 'onChange'}]" required type="number" name="基本工资" label="基本工资" placeholder="0.00" @change="numToFixed(applyData.basePay,'basePay')" />
						<van-field v-model="applyData.perfomPay" :disabled="isDetail" type="number" name="绩效工资" label="绩效工资" placeholder="0.00" @change="numToFixed(applyData.perfomPay,'perfomPay')" />
						<van-field disabled :value="!isDetail ? allCount : applyData.totalPay" placeholder="0.00" name="月工资合计" label="月工资合计"/>
						<van-field class="select" is-link v-if="!isDetail" v-model="yearBonusNumDescr" clickable readonly prop="yearBonusNum" label="目标年终奖" placeholder="请选择目标年终奖"
						 @click="selectValue(yearBonusMonthNumList,'yearBonusMonthNumList')"/>
						<van-field v-else disabled v-model="applyData.yearBonusNumDescr"  label="目标年终奖"/>
						<van-field v-if="optionNumShow" type="number" v-model="applyData.optionNum" :disabled="isDetail" name="期权授予数量" label="期权授予数量" placeholder="0" @input="applyData.optionNum=applyData.optionNum.replace(/[^\d]/g,'')" :maxlength="15" />
						<!-- <van-field type="switch" v-model="applyData.shareSubsidy" :disabled="isDetail" name="是否享受双外补助" label="是否享受双外补助"  /> -->
						<van-field v-if="applyData.emplType==='37'" name="switch" label="是否享受双外补助">
							<template #input >
								<van-switch 
									:disabled="isDetail || isSubsidyFlag"
									v-model="applyData.shareSubsidy"
									size="20" 
									active-value="Y"
									inactive-value="N"
									active-color="#05B555" 
									inactive-color="#dcdee0"/>
							</template>
						</van-field>
					</div>
				</div>
				<!-- 社保公积金信息 -->
				<div class="con-filed" v-if="socailFlag === 'Y'">
					<div class="con-title">
						社保公积金信息
						<i class="van-icon van-icon-arrow van-cell__right-icon u-arrow--unexpanded"
                	:class="{'u-arrow--expanded': socialExpandFlag}" @click="socialExpandFlag = !socialExpandFlag"></i>
					</div>
					<SocialInfo
						v-if="socialExpandFlag"
						:applyData="applyData"/>
				</div>
				<!-- 附件 -->
				<div class="con-filed">
					<div class="con-title">
						附件
						<i class="van-icon van-icon-arrow van-cell__right-icon u-arrow--unexpanded"
                	:class="{'u-arrow--expanded': attachExpandFlag}" @click="attachExpandFlag = !attachExpandFlag"></i>
					</div>
					<Attachment
						@changeLoading='changeLoading'
						v-if="attachExpandFlag"
						:isDetail="isDetail"
						:applyData="applyData"/>
				</div>
				<!-- 背调授权书模板 -->
				<!-- <div
					class="con-filed"
					v-if="!isDetail">
					<div class="con-title">
						背调授权书模板
						<i class="van-icon van-icon-arrow van-cell__right-icon u-arrow--unexpanded"
                	:class="{'u-arrow--expanded': temExpandFlag}" @click="temExpandFlag = !temExpandFlag"></i>
					</div>
					<div
						v-if="temExpandFlag"
						@click="getBgCheck"
						class="attach-template">下载背调授权书模板</div>
				</div> -->
				<div class="con-filed fixed-btn" v-if="!isDetail">
					<p class="submit-btn submit-app">
						<van-button round block type="info" @click="submitForm('applyData')" >提交</van-button>
					</p>
				</div>
			</van-form>
		</div>
		
		<van-popup v-model="showPicker"  position="bottom">
			<van-picker
				title="请选择"
				show-toolbar
				:value-key="keyValue"
				:columns="columns"
				@confirm="onConfirm"
				@cancel="showPicker = false"/>
		</van-popup>
		<Loading :visible='loading'/>
	</section>
</template>

<script>
import Vue from 'vue'
import { Notify } from 'vant'
Vue.use(Notify)

import NativeApi from 'native-api'
import BaseInfo from '../../components/m-base.vue'
import JobInfo from '../../components/m-job.vue'
import SocialInfo from '../../components/apply/m-social.vue'
import Attachment from '../../components/apply/m-attach.vue'
import Loading from '../../components/common/Loading'
import {
	applySubmit, getDetailApply, getCompanyInfo, getEmpType, getBgCheck, getSocialInfo
} from '../../network'
import { staticList } from '../../network/staticList'

export default {
	name: 'apply',
	components: {
		BaseInfo,
		JobInfo,
		SocialInfo,
		Attachment,
		Loading,
	},
	data() {
		return {
			applyData: {
				company: '', // 合同主体
				emplType: '', // 人员类别
				basePay: '', // 基本工资
				perfomPay: '', // 绩效工资
				totalPay: '', // 月工资
				lastNameSrch: '', // 姓
				lastNameAc: '', // 姓拼音
				firstNameSrch: '', // 名
				firstNameAc: '', // 名拼音
				fullName: '', //名字拼音
				country: 'CHN', // 国籍
				nationalIdType: '1A', // 证件类型
				nationalId: '', // 证件号（加密）
				sex: '', // 性别: M 女  F男
				phone: '', // 电话号码
				email: '', // 邮箱
				channel: '', // 招聘渠道
				recomUser: '', // 推荐人

				deptId: '', // 部门id
				supervisorId: '', // 直接上级
				seqRank:'', // 职级
				jobCode: '', // 职务
				expEntryDate: '', // 入职日期
				location: '', // 地点
				birthDate: '',//出生日期
				curResidentAddress: '',//现居地
				driverLicenseType: '',//驾照类型
				driverLicenseEffectDate: '',//驾照有效期
				emergencyContactor: '',//紧急联系人
				emergencyContactorPhone: '',//紧急联系人电话
				relationWithSelf: '',//与本人关系
				politicalStatus:'',//政治面貌
				yearBonusNum:'',//年终奖月数
				optionNum:'',//期权数量
				shareSubsidy:"",//是否享受双外补助
				hrAttachs: [{
					pageModual: 'oth',
					pageModualDesc: '其他',
					attachModule: 'outside',
					delFlag: '0',
				}], // 附件
			},
			socailFlag: '', // 是否显示社保信息
			emplTypeTransCode: '', // 员工类别
			companyTypeList: [
				{
				companyCode:'',
				companyName:'',
				showFlag:''
				}
			],
			yearBonusMonthNumList: [],
			emplTypeList: [], // 人员类型列表
			isCheckId: false, // 判断是否通过身份验证
			isDisabled: false, // 防止提交成功重复点击
			isDetail: false,  // 判断是否详情
			companyName: '',
			emplTypeName:'',
			yearBonusNumDescr: '',
			columns:[],
			typeVal:'',
			keyValue: '', // picker 的key-value
			showPicker: false,
			expandFlag:true,
			baseExpandFlag:true,
			jobExpandFlag:true,
			payExpandFlag:true,
			socialExpandFlag: true,
			attachExpandFlag: true,
			temExpandFlag: true,
			rules:{
				company: [{ required: true, message: '合同主体不能为空' }],
				emplType: [{ required: true, message: '人员类别' }],
				lastNameSrch: [{ required: true, message: '姓不能为空' }],
				firstNameSrch: [{ required: true, message: '名不能为空' }],
				lastNameAc: [{ required: true, message: '姓拼音不能为空' }],
				firstNameAc: [{ required: true, message: '名拼音不能为空' }],
				fullName: [{ required: true, message: '姓名拼音不能为空' }],
				country :[{ required: true, message: '国籍不能为空' }],
				nationalIdType: [{ required: true, message: '证件类型不能为空' }],
				nationalId: [{ required: true, message: '证件号码不能为空' }],
				phone: [{ required: true, message: '手机号不能为空' }, { pattern: /^1[0-9]{10}$/, message: '手机号格式有误' }],
				channel: [{ required: true, message: '招聘渠道不能为空' }],
				recomUser: [{ required: true, message: '推荐人不能为空' }],
				deptId: [{ required: true, message: '部门不能为空' }],
				supervisorId: [{ required: true, message: '直接上级不能为空' }],
				jobCode: [{ required: true, message: '职务不能为空' }],
				expEntryDate: [{ required: true, message: '入职时间不能为空' }],
				seqRank: [{ required: true, message: '职级不能为空' }],
				location: [{ required: true, message: '工作地点不能为空' }],
				basePay: [{ required: true, message: '请填写基本工资' }],
			},
			isShowPay: false, // 是否展示工资
			loading: false,
			getIsSubsidyParams : {
				workLocation:'',
				jobCode:'',
				emplType:'',
			},
			isSubsidyFlag:true,
			optionNumShow: false,
		};
	
	},
	computed: {
		allCount() {
			let allFee = Number(this.applyData.basePay) + Number(this.applyData.perfomPay)
			if(isNaN(allFee)){
				return ''
			}
			allFee = (Math.round(allFee * 100) / 100).toFixed(2)
			this.applyData.totalPay = allFee
			let { accFoundMax, houseAccFundBase, curDownLimit } = this.applyData
			if (houseAccFundBase === 'SAL' && accFoundMax > allFee) {
				this.applyData.houseAccFundBaseMax = allFee
			} else if (houseAccFundBase === 'SAL') {
				this.applyData.houseAccFundBaseMax = accFoundMax
			}
			return allFee
		},
	},
	created() {
		this.yearBonusMonthNumList = staticList.yearBonusMonthNumList
		this.optionNumShow = this.$route.query.optionNumShow === 'true'
		//如果是详情页
		if(this.$route.query && this.$route.query.bizId) {
			this.isDetail = true
			this.getDetailApply()
		}else{
			this.isDetail = false;
			// 合同主体
			this.fetchCompanyList()
			// 员工类别
			this.fetchEmpTypeList()
		}
	},
	watch:{
		'applyData.emplType'(newData) {
			if (newData!=='37') {
				this.getIsSubsidyParams.jobCode = ''
				this.isSubsidyFlag = true;
				this.applyData.shareSubsidy = 'N'
			}
		}
	},
	methods: {
		getIsSubsidyFlag(data){
			this.isSubsidyFlag = true
			this.applyData.shareSubsidy = 'N'
			this.getIsSubsidyParams[data.code] = data.val
			setTimeout(()=>{
				if(this.getIsSubsidyParams.workLocation !== '' && this.getIsSubsidyParams.jobCode !== '' && this.getIsSubsidyParams.emplType !== ''){
					getSocialInfo(this.getIsSubsidyParams).then((data)=>{
						let shareSubsidy = data.data.data.shareSubsidy
							shareSubsidy === 'Y' ? this.isSubsidyFlag = false : this.isSubsidyFlag = true
					})
				}
			},1000)
		},
		changeLoading(flag) {
			this.loading = flag
		},
		submitForm(){
			this.$refs.applyForm.validate().then(() => {
                if(this.isCheckId){
					if (!this.isShowPay) {
						this.applyData = Object.assign(this.applyData, { basePay: '', perfomPay: '' })
					}else {
						if(this.applyData.perfomPay === ''){
							this.applyData.perfomPay = '0.00'
						}
						if(this.applyData.basePay === '0.00'){
							Notify({ type: 'danger', message: '基本工资不能为0' })
							return
						}				
					}
					// 校验附件
					let hrAttachs = [...this.applyData.hrAttachs]
					let { company } = this.applyData
					hrAttachs = hrAttachs.filter(item => item.fileUniqueId)
					// if (company === 'V01' && hrAttachs.findIndex((item) => item.pageModual === 'back_check') === -1) {
					// 	Notify({ type: 'danger', message: '请上传背调授权书' })
					// 	return
					// }
					this.applyData.hrAttachs = hrAttachs
					let params = this.applyData
					this.isDisabled = true
					return applySubmit(params).then((res)=>{
						let data = res.data
						if(data.code === 'S00000') {
							this.isDisabled = false
							Notify({ type: 'success', message: '提交成功' })
							this.isDetail = true
							setTimeout(()=>{
								NativeApi.invoke('close', null, () => {})
							},1000)
						}else{
							Notify({ type: 'danger', message: data.message })
							this.isDisabled = false
						}
					}).catch((error)=>{
						Notify({ type: 'error', message: error.response.data.message })
						this.isDisabled = false
					})
				}else{
					Notify({ type: 'warning', message: '身份验证未通过，请验证身份' })
				}
            })
			
		},
		empTypeChange(val){
			this.$refs.jobInfo.resetJob()
			this.clearSocail()
		},
		// 合同主体
		fetchCompanyList(){
			// NB 内部，WB 外部
			getCompanyInfo({ companyNature: 'WB' }).then((res) => {
				let data =res.data
				if(data.code === 'S00000'){
					this.companyTypeList = data.data || [];
				} else {
					this.$message.error(data.message)
				}
			}).catch(() => {})
		},
		// 员工类别
		fetchEmpTypeList(){
			let { company } = this.applyData
			getEmpType({ company }).then((res) => {
				let data = res.data
				if(data.code === 'S00000'){
					this.emplTypeList = data.data || [];
				} else {
					this.$message.error(data.message)
				}
			}).catch(() => {})
		},
		selectValue(list, type, keyValue = 'label'){
			this.showPicker = true
			this.columns = list 
			this.typeVal = type
			this.keyValue = keyValue
		},
		onConfirm(value){
			if(this.typeVal === 'companyTypeList'){
				let { companyCode, companyName } = value
				this.applyData.company = companyCode
				this.companyName = companyName
				// 根据合同主体请求员工类别接口
				this.fetchEmpTypeList()
				this.$set(this.applyData, 'emplType', undefined)
				this.emplTypeName = undefined
				this.socailFlag = ''
				this.emplTypeTransCode = ''
				
				if(value.showFlag==='Y'){
					this.isShowPay = true;
				} else {
					this.applyData = Object.assign(this.applyData, { basePay: '', perfomPay: '' })
					this.isShowPay = false;
				}
			}
			if(this.typeVal === 'emplTypeList'){
				let { emplTypeCode, emplTypeName, socailFlag, emplTypeTransCode } = value
				if(this.applyData.emplType !== emplTypeCode){
					this.empTypeChange()
				}
				this.applyData.emplType = emplTypeCode
				this.emplTypeName = emplTypeName
				this.socailFlag = socailFlag
				this.emplTypeTransCode = emplTypeTransCode
				this.getIsSubsidyFlag({code:'emplType',val:emplTypeCode || ''})
			}
			if(this.typeVal === 'yearBonusMonthNumList'){
				this.applyData.yearBonusNum = value.value
				this.yearBonusNumDescr = value.label	
			}
			this.showPicker = false
		},
		// 检查身份证信息是否校验通过
		checkId(data){
			this.isCheckId = data
		},
		// 获取详情接口
		getDetailApply(){
			return getDetailApply({bizId: this.$route.query.bizId}).then((res)=>{
				let data = res.data
				if(data.code === 'S00000'){
					this.applyData = data.data[0]
					this.socailFlag = this.applyData.socailFlag
					this.applyData.fullName = this.applyData.nameAc
					if(!this.applyData.basePay){
						this.applyData.basePay = '0'
					}
					if(!this.applyData.totalPay){
						this.applyData.totalPay = '0'
					}
					if(!this.applyData.perfomPay){
						this.applyData.perfomPay = '0'
					}
				}else{
					Notify({ type: 'danger', message: 'data.message' });
				}
			}).catch((error)=>{
				//this.$message.error(JSON.stringify(error))
			})
		},
		// 校验是否数字
		_checkRate(input) {
            let re = /^[0-9]+.?[0-9]*$/ // 判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/
            if (!re.test(input)) {
                return false
            }
            return true
		},
		_parseFloat(valString) {
            if (!valString) {
                return 0
            }
            return parseFloat(valString)
        },
		// 输入框保留两位小数
        numToFixed(val,filed) {
			let inputValue = this._parseFloat(val).toFixed(2)
            if (this._checkRate(inputValue) && this.applyData[filed] != '') {
				this.applyData[filed] = inputValue
            } else {
                this.applyData[filed] = ''
            }
		},
		clearSocail() {
			this.$set(this.applyData, 'socialInsuranceLocation', '')
			this.$set(this.applyData, 'socialInsuranceLocationDescr', '')
			this.$set(this.applyData, 'beRegularEmpPay', '')
			this.$set(this.applyData, 'socialInsuranceBase', '')
			this.$set(this.applyData, 'accidentInsurance', '')
			this.$set(this.applyData, 'accidentInsuranceMedicine', '')
			this.$set(this.applyData, 'houseAccFundBase', '')
			this.$set(this.applyData, 'houseAccFundBaseMax', '')
			this.$set(this.applyData, 'accFoundMax', 0)
			this.$set(this.applyData, 'curDownLimit', 0)
		},
		async getBgCheck() {
			let res = await getBgCheck().catch({})
			if (!res) return
			if (res.data.data) {
				NativeApi.invoke('downloadFile', {
					fileUrl: res.data.data,
					fileName: '背调授权书模板.pdf',
				})
			}
		},
	},
}
</script>
<style lang="scss">
 // 移动端样式
  .moblie-wrapper{
	  padding-bottom:64px;
	  &.external-container{
		  width:100%;
		  overflow-x:hidden;
		  .name-vali .tip{
			  margin-bottom:15px;
			  position:static;
			  width:100%;
			  font-size:11px;
		  }
		  .el-form-item__label{
			  padding-right: 0;
			  width: 90px;
			  white-space: nowrap;

		  }
		  .nation-vali .tip{
			  position:static;
			  width:100%;
			  font-size:11px;
		  }
		  .nation-vali .el-button{
			  margin-left:0;
		  }
		  .con-filed.cash-filed .con-list {
			  .inline-filed{
				  display:flex;
			  }
			  .el-input{
				-webkit-flex:1;
			  	flex:1;
			  }
		  }
		  .con-filed .con-list ul{
			  padding-left:0;
			  .inline-filed{
				  display:block;
			  }
		  }
		  .con-filed .con-list .label-tit{
			  text-align:left;
			  width: 93px;
			  white-space: nowrap;
		  }
		  .el-form-item__label{
			  text-align:left;
		  }
		  .el-form-item{
			  display:flex;
		  }
		  .el-form-item__content{
			  -webkit-flex:1;
			  flex:1;
			  .el-input, .el-select{
				  width:100%;
			  }
		  }
	  }
	  .header{
		  height:50px;
		  line-height:50px;
	  }
	  .con-filed{
		  padding: 0 14px;
	  }
	  
  }
.external-container.moblie-wrapper{
	background-color: #f2f4f6;
	margin-top: 8px;
	.van-field__label{
		width: 128px;
	}
	.submit-app{
		width: 100%;
		margin-left:0;
		left: 0;
	}
	.van-field__error-message{
		padding-right:16px;
		text-align:right;
	}
	.van-picker__toolbar{
		height: 50px;
		line-height: 50px;
		border-bottom:1px solid #F2F2F2;
		.van-picker__title{
			font-size: 17px;
			color: #222;
		}
		.van-picker__cancel{
			color: #C6CBD1;
		}
	}
	.con-list{
		margin-bottom:0;
	}
	.con-filed{
		background-color: #fff;
		margin: 0 12px 8px;
		padding:0;
		border-radius:8px;
		overflow: hidden;
		.con-title{
			font-size:16px;
			color: #333;
			font-weight: 500;
			margin:0;
			height: 46px;
			line-height:46px;
			padding:0 0 0 19px;
			.van-icon-arrow{
				position: absolute;
				top: 12px;
				right:0px;
				font-size: 14px;
				-webkit-transform: rotate(90deg);
				transform: rotate(90deg);
				&.u-arrow--expanded{
					-webkit-transform: rotate(-90deg);
					transform: rotate(-90deg);
					right:10px;
					top: 9px;
				}
			}
			&:after{
				width: 3px;
				height: 10px;
				top:18px;
				left: 12px;
				background:url('../../assets/title-bg.png') no-repeat;
				background-size: 100% auto;
			}
		}
	}
	padding-top: 0;
	width: 100%;
	.select .van-field__body{
		position: relative;
	}
	.van-field__label{
		padding:9px 0;
		font-size:14px;
		line-height: 14px;
	}
	.van-cell--required::before{
		color: transparent;
		width: 0;
		height: 0;
	}
	.van-cell--required .van-field__label span::after {
		position: relative;
		color: #FA5050;
		font-size: 12px;
		content: '*';
		margin-left: 5px;
		top: 2px;
	}
	input.van-field__control{
		-webkit-appearance: none;
		text-align:right;
		appearance: none;
		border: 1px solid transparent;
		border-radius: 4px;
		height: 32px;
		padding: 0 16px 0 0;
		box-sizing: border-box;
	}
	.van-field__control{
		text-align:right;
	}
	.van-field__control--custom,
	.van-radio-group{
		display:inline-block;
		text-align:right;
		vertical-align:-11px;
	}
	.van-radio-group{
		margin-right: 4px;
		>div{
			float: left;
			margin-left: 10px;
		}
	}
	.select{
		.van-field__error-message{
			padding-right:0;
			margin-right: -16px;
		}
		input.van-field__control{
			padding-right: 1px;
		}
		input:disabled.van-field__control{
			padding-right: 16px;
		}
	}
	.search-wrap.van-popup{
		border-radius:0;
	}
	.van-search{
		input.van-field__control{
			text-align: left;
		}
	}
	.van-cell__right-icon{
		margin-right: 10px;
	}
	.van-cell{
		padding:6px 0 6px 16px;
	}
	.van-cell__value{
		font-size: 14px;
		color: #C6CBD1;
	}
	.van-search .van-cell{
		padding-right:8px;
	}
	textarea.van-field__control{
		border: 1px solid transparent;
		border:none;
		border-radius: 4px;
		padding: 0 5px;
		box-sizing: border-box;
	}
	.comptextarea{
		.van-field__control{
			text-align:right;
			min-height: auto;
			padding: 5px 0 5px 5px;
		}
		.van-cell{
			line-height:19px;
		}
	}
	.comp-detail{
		.van-field__control{
			padding-right: 16px;
		}
	}
	.van-field__label,
	.van-calendar__day.van-calendar__day--disabled{
		color:#333;
	}
	.van-field__control::placeholder{
		color: #C6CBD1;
	}
	.van-field__control,
	.van-picker-column__item,
	.van-search__action,
	.van-cell,
	.van-calendar__header-title,
	.van-calendar__header-subtitle,
	.van-calendar__day,
	.van-calendar__month-title{
		color: #333;
	}
	
	.van-cell:not(:last-child)::after{
		border-color: #ebedf0;
		transform: scaleY(0.5);
	}
	.van-field__left-icon .van-icon, 
	.van-field__right-icon .van-icon{
		color:#05B555;
		font-weight: 900;
	}
	.van-radio__icon--checked .van-icon{
		background-color: #04D777;
		border-color: #04D777;
	}
	.van-picker__cancel, .van-picker__confirm{
		color: #05B555;
	}
	
}
.van-popup--top.van-notify--warning{
	background-color: #FFF1F0;
}
.van-popup--top.van-notify{
	color: #F34848
}
.attach-template{
	color: #11ca78;
	font-size: 14px;
	line-height: 32px;
	padding:0 12px 12px;
	cursor: pointer;
	text-align: right;
}
</style>
